module.exports = __webpack_public_path__ + "static/media/print-logo-3.ec69fdca.png";